import * as Yup from 'yup';
import { IntlShape } from 'react-intl';
import { fields } from '@synergy/utils';

import { InvoiceNumberSequenceFormValues } from './models/invoice-number-sequence-form-values';

const fieldNames = fields<InvoiceNumberSequenceFormValues>();

export const invoiceNumberSequenceValidationSchema = (
    intl: IntlShape,
    prefix?: string,
    nextFreeNumber = 0,
    isDefault?: boolean
) => {
    const validateFirstNumber = Yup.number()
        .typeError('app.error.required')
        .required('app.error.required')
        .min(1, 'app.error.greaterZero')
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .test('greaterCurrentNumber', 'app.error.invalidInvoiceNumber', (number: number | undefined, ctx: any) => {
            if (ctx.from[0].value.prefix !== prefix) {
                return true;
            }

            return !number || number >= nextFreeNumber;
        });

    if (isDefault) {
        return Yup.object().shape({
            [fieldNames.prefix]: Yup.string()
                .nullable()
                .min(2, 'app.error.minTwoCharacters')
                .max(20, v => intl.formatMessage({ id: 'app.error.maxLength' }, { value: v.max })),
            [fieldNames.firstNumber]: validateFirstNumber,
        });
    }

    return Yup.object().shape({
        [fieldNames.prefix]: Yup.string()
            .typeError('app.error.required')
            .required('app.error.required')
            .min(2, 'app.error.minTwoCharacters')
            .max(20, v => intl.formatMessage({ id: 'app.error.maxLength' }, { value: v.max })),
        [fieldNames.firstNumber]: validateFirstNumber,
        [fieldNames.suppliers]: Yup.array().of(Yup.object()).min(1, 'app.error.required'),
    });
};
